import React, { useState } from "react";
import { graphql, useStaticQuery } from "gatsby";

import { collaborationsPrepareData } from "utils/collaborationsPrepareData";
import { Heading } from "components/ui/Heading";
import { Section } from "components/common/Section";
import { Container } from "components/common/Container";
import { Banner } from "components/common/Banner";
import { ContactModal } from "components/common/ContactModal";

import { CollaborationCard } from "./CollaborationCard";
import * as s from "./Collaborations.module.sass";

export const Collaborations: FC = ({ className }) => {
  const data = useStaticQuery(graphql`
    query Collaborations {
      prismicCollaborations {
        data {
          header {
            text
          }
          items {
            label {
              text
            }
            image {
              gatsbyImageData(
                width: 384
                placeholder: BLURRED
                outputPixelDensities: 1.5
              )
            }
          }
          tab_text {
            text
          }
          tab_button_label {
            text
          }
        }
      }
    }
  `);

  const { header, items, banner } = collaborationsPrepareData(data);

  const [modalOpened, setModalOpened] = useState(false);

  return (
    <Section className={className}>
      <Container>
        <Heading className={s.heading}>{header}</Heading>
        <div className={s.collaborations}>
          {items.map((collaboration: any) => (
            <CollaborationCard
              key={collaboration.title}
              collaboration={collaboration}
              className={s.collaboration}
            />
          ))}
        </div>
        <Banner
          title={
            <>
              <span className={s.mobile}>{banner.headerMobile}</span>
              <span className={s.desktop}>{banner.header}</span>
            </>
          }
          button={{
            label: banner.button,
            onClick: () => setModalOpened(true),
          }}
          glassType="collaborations"
          className={s.banner}
        />
      </Container>
      <ContactModal
        isOpen={modalOpened}
        onRequestClose={() => setModalOpened(false)}
      />
    </Section>
  );
};
